module.exports = __webpack_public_path__ + "static/media/pit-bull.44e845eb.jpg";